import lottie from 'lottie-web';

const animation = {
  mounted() {
    this.animation = lottie.loadAnimation({
      container: this.$refs.animation,
      renderer: 'svg',
      loop: false,
      autoplay: this.autoPlay,
      animationData: this.animationData,
    });
    this.animation.onComplete = () => {
      this.$emit('ended');
    };
  },
  beforeDestroy() {
    if (this.animation) {
      this.animation.destroy();
    }
  },
  data: () => ({
    autoPlay: false,
    animation: null,
    animationData: null,
  }),
  watch: {
    show: {
      handler(nv) {
        if (nv && this.animation) {
          this.animation.play();
        }
      },
    },
  },
};

export default animation;
